import "jquery-focusable/jquery.focusable";
import "jquery-keyboard-trap/jquery.keyboardtrap";
//jQuery wrapper for the design system modals
//allows modals to be shown/hidden dynamically without button triggers.
$.fn.usaj_modal_close = function () {
    var target = $(this);
    var state = 'is-open';
    var $el = $(this),
        $this_modal = target,
        state = state,
        transition_to;

    if (state === 'is-closed') {
        transition_to = 'modal.open';
    } else {
        transition_to = 'modal.close';
    }
    for (var i = 0; i < this.length; i++) {
        this[i].dispatchEvent(new CustomEvent(transition_to, { 'detail': { el: $el, object: $this_modal, state: state } }));
    }
}

$.fn.usaj_modal_open = function () {
    var target = $(this);
    var state = 'is-closed';
    var $el = $(this),
        $this_modal = target,
        state = state,
        transition_to;

    if (state === 'is-closed') {
        transition_to = 'modal.open';
    } else {
        transition_to = 'modal.close';
    }
    for (var i = 0; i < this.length; i++) {
        this[i].dispatchEvent(new CustomEvent(transition_to, { 'detail': { el: $el, object: $this_modal, state: state } }));
    }
    var _id = "#" + $(target).attr('id');
    setInitialFocusModal(_id);
    //jQuery wrapper for the design system modals
    //allows modals to be shown/hidden dynamically without button triggers.
    $.fn.usaj_modal_close = function () {
        var target = $(this);
        var state = 'is-open';
        var $el = $(this),
            $this_modal = target,
            state = state,
            transition_to;

        if (state === 'is-closed') {
            transition_to = 'modal.open';
        } else {
            transition_to = 'modal.close';
        }

        for (var i = 0; i < this.length; i++) {
            this[i].dispatchEvent(new CustomEvent(transition_to, { 'detail': { el: $el, object: $this_modal, state: state } }));
        }
    }

    $.fn.usaj_modal_open = function () {
        var target = $(this);
        var state = 'is-closed';
        var $el = $(this),
            $this_modal = target,
            state = state,
            transition_to;

        if (state === 'is-closed') {
            transition_to = 'modal.open';
        } else {
            transition_to = 'modal.close';
        }

        for (var i = 0; i < this.length; i++) {
            this[i].dispatchEvent(new CustomEvent(transition_to, { 'detail': { el: $el, object: $this_modal, state: state } }));
        }
        var _id = "#" + $(target).attr('id');
        setInitialFocusModal(_id);
        $.trapKeyboard($(_id));
    }

    var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

    function setInitialFocusModal(obj) {
        // get list of all children elements in given object
        var o = $(obj).find('*');
        //alert(o);
        // set focus to first focusable item
        var focusableItems;
        focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();
    }
}

global.focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

global.setInitialFocusModal = function(obj) {
    // get list of all children elements in given object
    var o = $(obj).find('*');
    //alert(o);
    // set focus to first focusable item
    var focusableItems;
    focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();
}
